import { createStore } from "@xstate/store";

export const rootStore = createStore({
  context: {
    parentUrl: null as string | null,
  },
  on: {
    SET_PARENT_URL: (context, event: { parentUrl: string | null }) => ({
      ...context,
      parentUrl: event.parentUrl,
    }),
  },
});
